import { render, staticRenderFns } from "./PartitionNoticeModal.vue?vue&type=template&id=71ee605c&"
import script from "./PartitionNoticeModal.vue?vue&type=script&lang=js&"
export * from "./PartitionNoticeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports